import React from 'react';
import PropTypes from 'prop-types';
import { Chip, Divider, Skeleton, Stack, Typography } from '@mui/material';
import Card from '../common/Card';

const renderList = (items = []) => {
  if (!items.length) {
    return <Typography variant="body2" color="text.secondary">N/A</Typography>;
  }

  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
      {items.map((item) => <Chip key={item} label={item} size="small" />)}
    </Stack>
  );
};

const FieldRow = ({ label, value }) => (
  <Stack spacing={0.5}>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    {Array.isArray(value)
      ? renderList(value)
      : <Typography variant="body2">{value ?? 'N/A'}</Typography>}
  </Stack>
);

const ProfileCard = ({ title, profile, emptyMessage = 'No profile available', loading = false }) => {
  return (
    <Card title={title}>
      {loading ? (
        <Stack spacing={1.5}>
          <Skeleton variant="rounded" height={28} />
          <Skeleton variant="rounded" height={28} />
          <Skeleton variant="rounded" height={28} />
        </Stack>
      ) : !profile ? (
        <Typography variant="body2" color="text.secondary">{emptyMessage}</Typography>
      ) : (
        <Stack spacing={1.5} divider={<Divider flexItem />}>
          <FieldRow label="Allowed setups" value={profile.allowed_setups || []} />
          <FieldRow label="Blocked setups" value={profile.blocked_setups || []} />
          <FieldRow label="Preferred SL ATR" value={profile.preferred_sl_atr} />
          <FieldRow label="Preferred TP style" value={profile.preferred_tp_style} />
          <FieldRow label="Best sessions" value={profile.best_sessions || []} />
          <FieldRow label="Min confidence" value={profile.min_confidence} />
        </Stack>
      )}
    </Card>
  );
};

ProfileCard.propTypes = {
  title: PropTypes.string.isRequired,
  profile: PropTypes.object,
  emptyMessage: PropTypes.string,
  loading: PropTypes.bool,
};

export default ProfileCard;
